import Splide from '@splidejs/splide';

if (document.querySelector('.wp-block-preciseinvestigation-hero-slider')) {
  const splide = new Splide('.wp-block-preciseinvestigation-hero-slider.splide', {
    arrows: false,
  });

  splide.mount();
}
